import { unitMapping } from 'lib/style';

type Props = {
  size?: keyof typeof unitMapping;
  className?: string;
};

export const BaseballFirstBase = ({ size = 2, className }: Props) => (
  <svg
    className={className}
    style={{ width: unitMapping[size], height: unitMapping[size] }}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.9397 9.42917H7.14522L6.93657 10.6347H3.15002L3.35867 9.42917H4.57964L5.03557 6.86359L4.10052 7.38907L3.5055 6.33811L5.19785 5.37988H6.65065L5.9397 9.42917ZM12.8451 6.26856L12.6442 7.44316L12.0801 7.91455L12.5979 8.54822L12.3892 9.746L11.346 10.6347H7.63671L8.56403 5.37988H12.1187L12.8451 6.26856ZM11.0214 7.45862L11.2919 7.23452L11.3769 6.7554L11.2301 6.5854H9.73863L9.5918 7.45862H11.0214ZM11.091 9.22825L11.1682 8.80323L10.9596 8.54822H9.39861L9.24406 9.42917H10.8514L11.091 9.22825Z"
      fill="white"
    />
  </svg>
);
